/* eslint-disable object-shorthand */
import { useSelector } from 'react-redux';
/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { selectAuth } from '@/store/selectors';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetcher = ({ queryKey }: any) => {
  const url = queryKey[1];
  const owner = queryKey[2];
  const response = axios
    .get(
      `https://${url}/api/method/oyasync_integrations.oyasync_integrations.api.pos_app.pos_app.get_draft_invoices?owner=${owner}`,
      {
        withCredentials: true,
      },
    )
    .then((data) => data.data?.message)
    .catch((error) => error.response.message);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useFetchOrders = () => {
  const { url, cashierId } = useSelector(selectAuth);

  return useQuery(['orders', url, cashierId], fetcher);
};
